import styled from 'styled-components';
import { fadeIn } from '../../../constants/keyframes/fades';
import media from '../../../constants/media';
import { sequencedAnimationDelay } from '../../../helpers/styleHelpers/styleHelpers';
import { Column } from '../../base/grid';

export const ArticleColumn = styled(Column)`
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	perspective: 1000;
	-webkit-perspective: 1000;
	transform: translate3d(0, 0, 0);
	opacity: 0;
	animation: ${fadeIn} 500ms linear forwards;
	transition: filter 200ms ease;
	${sequencedAnimationDelay(11, 0.05)};

	${media.mobileOnly`
		padding: 0;
	`};
`;

export const NoArticlesFound = styled.div`
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	font-size: 4.2rem;
	margin: 6rem 0;
	text-align: center;
`;
